import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ICoursesForSubscriptions } from '.';

const apiDataProvider = new APIDataProvider();

const getCoursesByUser = createAsyncThunk(
  '/course-students/getCoursesByUser',
  async () => {
    const path = `${ApiPaths.courseStudent}`;

    const response = await apiDataProvider.get<
      TApiResponse<ICoursesForSubscriptions>
    >(path);

    return response.data;
  }
);

export default getCoursesByUser;
